import Table from '@/components/table/Table';
import { camelToTitle } from '@shared/utils/camelToTitle.js';
import { useCallback } from 'react';

const WorkflowOutputTable = ({ outputData }) => {
  const tableHeaders = useCallback(() => {
    if (outputData.length) {
      return Object.keys(outputData[0])?.map((key) => {
        return isNaN(key) ? camelToTitle(key) : parseInt(key) + 1;
      });
    }
    return [];
  }, [outputData]);

  const dataAsArray = outputData?.map((row) => {
    return Object.entries(row).map(([key, value]) => {
      value = typeof value === 'object' ? JSON.stringify(value) : value;
      const fullValue = value;
      value = value?.length > 40 ? `${value.slice(0, 40)}...` : value;
      return { key, value, fullValue: value !== fullValue ? fullValue : undefined };
    });
  });

  return (
    <>
      <Table showTableActionArea={false} isLoading={!outputData}>
        <>
          <thead>
            <tr>
              {tableHeaders().map((header, headerIndex) => (
                <th className="head-cell" key={headerIndex}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataAsArray.map((rowData, rowIndex) => (
              <tr key={rowIndex}>
                {rowData.map((cell, cellIndex) => (
                  <td key={cellIndex} data-title={cell.fullValue}>
                    {cell.value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </>
      </Table>
    </>
  );
};

export default WorkflowOutputTable;

// headerList={['header1', 'name']}
// tableData={[
//   {
//     rowData: [
//       { label: '1', value: 1, clickAction: () => console.log('1') },
//       { label: '12', value: 12 },
//     ],
//   },
//   {
//     rowData: [
//       { label: '2', value: 2, clickAction: () => console.log('2') },
//       { label: '22', value: 22 },
//     ],
//   },
// ]}
